export default __webpack_public_path__ + "static/media/5.ce43624a.svg";